import Proxy from './Proxy';

class ManagementProtocolTemplateProxy extends Proxy {
  /**
   * The constructor for the ManagementProtocolTemplateProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/ManagementProtocolTemplates', parameters);
  }

  getManagementProtocolTemplate(id) {
    return this.submit('get', `${this.endpoint}/${id}`);
  }

  getProtocolList() {
    return this.submit('get', `${this.endpoint}`);
  }
}

export default ManagementProtocolTemplateProxy;
